import React from 'react';
import { useSelectedLocationData, isRecordFound } from '../../../hooks/data-hooks';
import { useLanguageLocale } from '../../../hooks/language-locale-hooks';
import { SiteCards } from '../../../components/SiteCards';
import { LocationsDropdownToolbar } from '../../../components/LocationsDropdownToolbar/LocationsDropdownToolbar';
import { ContentContainer } from '../../../components/ContentContainer';
import { RecordDataIndicators } from '../../../components/RecordDataIndicators';
import { SiteAlarmListProvider } from '../../../data/DataProviders/SiteAlarmListProvider';

export const OverviewLocation: React.FC = () => {
    const { t } = useLanguageLocale();
    const selectedLocationData = useSelectedLocationData();

    return (
        <>
            <LocationsDropdownToolbar title={t('DASHBOARD.OVERVIEW_TITLE')} shouldIndicateAlarms />

            <ContentContainer justifyContent="start" testId="location-overview-page">
                <RecordDataIndicators
                    recordData={selectedLocationData}
                    errorMessage={t('DASHBOARD.ERROR_LOADING_LOCATION')}
                    notFoundIcon="LocationCity"
                    notFoundMessage={t('DASHBOARD.LOCATION_NOT_FOUND')}
                />

                {isRecordFound(selectedLocationData) && (
                    <SiteAlarmListProvider locationId={selectedLocationData.value.id}>
                        <SiteCards />
                    </SiteAlarmListProvider>
                )}
            </ContentContainer>
        </>
    );
};
